import React from "react";
import classNames from "classnames";
import DeleteIcon from "@material-ui/icons/Delete";

import { TextField } from "../../fields";
import { ButtonIcon } from "../../../Buttons/ButtonIcon/ButtonIcon";
import "./FieldGroupItem.scss";

export const FieldGroupItem = ({
    className,
    name,
    withIndex,
    index,
    fieldsProps,
    classNameField,
    classNameBtn,
    fields,
    onClearRow,
   hideDeleteRowButton = false
}) => (
    <div className={classNames("field-group-item", className)}>
        { withIndex && (<div className={"field-group-item__index"}>#{index + 1}</div>)}
        {
            fieldsProps.map(({
                nameField,
                placeholder,
                component,
                customStyles = {},
                ...restProps
            }, index)=>{
                const rootProps = {
                    name: nameField ? `${name}.${nameField}` : `${name}`,
                    placeholder: placeholder || "",
                    isRequired: true,
                    ...restProps
                };
                const InputComponent = component ? component(rootProps) : <TextField {...rootProps} />;

                return (
                    <div
                        key={index}
                        className={classNames("field-group-item__field", classNameField)}
                        style={customStyles}
                    >
                        {InputComponent}
                    </div>
                );
            })
        }
        {
            !hideDeleteRowButton && (
                <div className={classNames("field-group-item__btn", classNameBtn)}>
                    <ButtonIcon
                        warning
                        title={"Delete"}
                        onClick={() => onClearRow ? onClearRow(index) : fields.remove(index)}
                    >
                        <DeleteIcon/>
                    </ButtonIcon>
                </div>
            )
        }
    </div>
);
